import { Link } from 'react-router-dom'
import logo from '@/assets/logo.svg'

export const HeaderBranding = () => {
  return (
    <h1 className="text-base font-medium">
      <Link to="/" className="flex items-center">
        <img src={logo} alt="myra labs" className="w-12 h-12" />
        <span className="font-semibold tracking-tight">
          myra<span className="text-muted-foreground">labs</span>
          <em className="not-italic text-primary">.ai</em>
        </span>
      </Link>
    </h1>
  )
}
